'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Streamer = undefined;

var _themeProvider = require('@spp/theme-provider');

var _Streamer = require('./Streamer');

var _Streamer2 = _interopRequireDefault(_Streamer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Streamer = _Streamer2.default;
exports.default = (0, _themeProvider.themer)('@spp/ui-streamer')(_Streamer2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-streamer/lib/cjs/index.js
 ** module id = 672
 ** module chunks = 1
 **/